import React from "react";

import {
  sectionHeadingStyle,
  sectionContainerStyle,
  headingContainerStyle,
  bioStyle,
} from "./components/styles";
import SkillCardItem from "./components/SkillCard";

const Personality = () => {
  const personalityTraits = [
    { title: "Funny" },
    { title: "Innovative" },
    { title: "Communicative" },
    { title: "Self-Motivated" },
    { title: "Goal-Oriented" },
    { title: "Open-Minded" },
    { title: "Reliable" },
    { title: "Curious" },
    { title: "Creative" },
    { title: "Resilient" },
    { title: "Adaptable" },
    { title: "Collaborative" },
    { title: "Detail-Oriented" },
    { title: "Analytical" },
    { title: "Proactive" },
    { title: "Problem-Solver" },
  ];

  return (
    <div style={sectionContainerStyle}>
      <div style={headingContainerStyle}>
        <h2 style={sectionHeadingStyle}>Personality</h2>{" "}
      </div>
      <p style={bioStyle}>
        This is how I am at work and in-person, ranking by how soon you see it.
      </p>
      <div className="chip-grid">
        {personalityTraits.map((object, i) => (
          <SkillCardItem key={i} obj={object} />
        ))}
      </div>
    </div>
  );
};

export default Personality;
